import React from "react";
import {AuthConsumer} from "./AuthProvider";
import {IAuthService} from "./services/auth-service";

export const LogoutCallback = () => (
    <AuthConsumer>
        {({signoutRedirectCallback}: IAuthService) => {
            signoutRedirectCallback();
            return <span>redirecting, please wait...</span>;
        }}
    </AuthConsumer>
);
